import { render, staticRenderFns } from "./EditMessageModal.vue?vue&type=template&id=3cf39b4a"
import script from "./EditMessageModal.vue?vue&type=script&lang=js"
export * from "./EditMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports